import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import Spinner from '@/components/UI/Spinner/Spinner';
import TooltipComponent from '@/components/UI/Tooltip/TooltipComponent';
import useAuth from '@/hooks/useAuth';
import { ModelSeriesInfo } from '@/types/Dashboard';
import styles from './Dashboard.module.scss';

type TileProps = {
  id: string;
  link?: string;
  title?: string;
  icon: string;
  display?: string | number;
  show?: boolean;
  subtitle?: string;
  dateMessage?: string;
  date?: string;
  messageTitle?: string;
  isTask?: boolean;
  onClick?: (ev: React.MouseEvent<HTMLDivElement>) => any;
  isDisplayLoading: boolean;
  subCROrCRId?: string;
  modelSeries?: ModelSeriesInfo[];
};

const ROLES_WITHOUT_COUNTER = [];

const TooltipComponentWithChildren = TooltipComponent as React.FC<any>;

const Tile: React.FC<TileProps> = (props) => {
  const { id, link, title, icon, display, show = true, subtitle, dateMessage, date, messageTitle, isTask = false, isDisplayLoading,
    onClick = () => null, subCROrCRId = '', modelSeries } = props;
  const titleStyle = styles[isTask ? 'TaskCardTitleMyAreas' : 'CardTitleMyAreas'];
  const headerStyle = isTask ? styles.TaskCardHeader : '';
  const authService = useAuth();
  const { t } = useTranslation();

  if (!show) return <></>;
  if (!link) {
    return (
      <div id={id || title} data-testid={id || title} className={styles.CardContent} onClick={onClick}>
        <div className={styles.CardTitleMyAreas}>{title}</div>
        <div className={styles.MyAreasIcoSection}><i className={`${icon} ${styles.CardIco}`} /></div>
      </div>
    );
  }

  const displayCampaignsOverview = () => (
    !isDisplayLoading
      ? (
        <>
          <i className={`${icon} ${styles.CardIco}`} />
          <span className={styles.NumberOpenRequests}>
            {authService?.checkRoles(ROLES_WITHOUT_COUNTER) ? t('notAvailable') : (display)}
          </span>

        </>
      )
      : (<Spinner isVisible />));

  return (
    <Link to={link} className={isTask ? styles.TaskCardContent : styles.CardContent} id={id || title} data-testid={id || title}>
      <div className={headerStyle}>
        {isTask && (<i className={`${icon} ${styles.TaskCardIco}`} />)}
        <div>
          <div className={titleStyle}>{title}</div>
          <div className={isTask && modelSeries?.length ? styles.TaskSubTitleRow : undefined}>
            <TooltipComponentWithChildren disableHoverListener={!isTask} title={subtitle} any="true">
              <span className={styles.TaskSubTitle}>{subtitle}</span>
            </TooltipComponentWithChildren>
            {
              isTask && modelSeries?.length && (
                <div className={styles.TaskModelSeriesList}>
                  {modelSeries.map((modelSerieInfo) =>
                    modelSerieInfo.typeVersions?.map((typeVersion, typeVersionIdx) => (
                      <TooltipComponentWithChildren key={`${modelSerieInfo.modelSerie}-${typeVersionIdx}`} title={`${modelSerieInfo.modelSerie}-${typeVersion}`}>
                        <span className={styles.TaskSubTitle}>{modelSerieInfo.modelSerie}-{typeVersion}</span>
                      </TooltipComponentWithChildren>
                    ),
                    ),
                  )}
                </div>
              )
            }
          </div>
        </div>
      </div>
      <div className={styles.MyAreasIcoSection}>
        {isTask
          ? (
            <div className={styles.TaskMessage}>
              <p>{messageTitle}{display && ':'}</p>
              <TooltipComponentWithChildren title={display}>
                <p className={styles.TaskDisplay}>{display && `"${display}"`}</p>
              </TooltipComponentWithChildren>
              <p>{dateMessage && `${dateMessage} `}{date}</p>
              <TooltipComponentWithChildren title={subCROrCRId}>
                <p className={styles.TaskDisplay}>{subCROrCRId}</p>
              </TooltipComponentWithChildren>
            </div>
          )
          : (
            displayCampaignsOverview()
          )}
      </div>
    </Link>
  );
};

export default Tile;
